import { CategoryScale, Legend, LinearScale, LineElement, PointElement, TimeScale, Title, Tooltip } from 'chart.js';
import { Chart as ChartJS } from 'chart.js/auto';
import 'core-js/stable';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import 'regenerator-runtime/runtime';
import de from '../i18n/de.json';
import fr from '../i18n/fr.json';
import it from '../i18n/it.json';
import App from './App.tsx';
import { AuthContextProvider } from './contexts/auth.context.tsx';
import './index.css';
import { useAppStore } from './stores/app.store.ts';

// register charts
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

// Supported languages
export type SupportedLanguage = 'de' | 'en' | 'fr' | 'it';

// setup i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

ReactDOM.createRoot(document.getElementById('root')!, {
  onCaughtError: (_error, errorInfo) =>
    useAppStore.getState().setLastComponentStack(errorInfo.componentStack ?? undefined),
  onUncaughtError: (_error, errorInfo) =>
    useAppStore.getState().setLastComponentStack(errorInfo.componentStack ?? undefined),
}).render(
  <>
    <React.StrictMode>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </React.StrictMode>
  </>,
);
